import { render } from "./ToolTip.vue?vue&type=template&id=72cb41ec"
import script from "./ToolTip.vue?vue&type=script&lang=js"
export * from "./ToolTip.vue?vue&type=script&lang=js"

import "./ToolTip.vue?vue&type=style&index=0&id=72cb41ec&lang=scss"

import exportComponent from "/Users/rantalmor/Desktop/volta-vue/proposal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__